import { Pipe, PipeTransform } from '@angular/core'

export const DEFAULT_FLOAT_DECIMALS = 2

export function roundFloat(value: number, numberOfDecimals: number = DEFAULT_FLOAT_DECIMALS): string {
  return value.toFixed(numberOfDecimals)
}

/*
 * Rounds the given float.
 * Takes the number of decimals as an argument (defaults to 2).
 * Usage:
 *   value | roundFloat
 * Example:
 *   {{ 2.146 | roundFloat }}
 *   => 2.15
 */
@Pipe({ name: 'roundFloat' })
export class RoundFloatPipe implements PipeTransform {
  transform(value: number, numberOfDecimals: number = DEFAULT_FLOAT_DECIMALS): string {
    return roundFloat(value, numberOfDecimals)
  }
}
